import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper dashboard-container" }
const _hoisted_2 = {
  key: 1,
  class: "no-dash"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardTwo = _resolveComponent("DashboardTwo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h4", null, "Report Dashboard", -1)),
    (_ctx.widgets)
      ? (_openBlock(), _createBlock(_component_DashboardTwo, {
          key: 0,
          widgets: _ctx.widgets,
          liveData: _ctx.liveData,
          isLoading: !!_ctx.isLoading
        }, null, 8, ["widgets", "liveData", "isLoading"]))
      : (_ctx.noDash)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "No Dashboard available..."))
        : _createCommentVNode("", true)
  ]))
}